const commentList = () => import('@/pages/product/comment/index.vue');

export default [{
    path: '/product/comment',
    component: commentList,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '评论列表',
        activeRoute: '/product/comment'
    }]
}];